import ClienteForm from "./ClienteForm";
export default ClienteForm;